module.exports = __webpack_public_path__ + "static/media/shahwork.425a50a3.png";